import { AuthService } from 'app/auth/auth.service';
import { Component, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'dialog-forgot-password',
  templateUrl: './dialog-forgot-password.component.html',
  styleUrls: ['./dialog-forgot-password.component.scss']
})
export class DialogForgotPasswordComponent implements OnInit {

  userId: string;
  loading: boolean = false;
  message: string;
  confirmRecover: boolean = true;
  sucess: boolean = false;

  constructor(
    protected dialogRef: NbDialogRef<DialogForgotPasswordComponent>,
    private authService: AuthService
  ) {}

  ngOnInit(): void { }

  recoverPassword(){
    this.dialogRef.onBackdropClick.subscribe(() => {});
    this.confirmRecover = false;
    this.loading = true;
    this.authService.passwordRecovery(this.userId).subscribe((value) => {
      
      if(value.data.data != null){
        this.message = value.data.data;
        this.sucess = true;
      }
      else
        this.message = value.data.message;

    }).add(() =>{
      this.loading = false;
    })
  }

  confirm(){
    this.dialogRef.close()
  }

}
